var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExplosives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "explosives-a",
    d: "M24.33674,43.823611 L29.5112518,48.4415993 L33.561149,48.0984312 L34.0444119,57.0310831 L41.4128858,55.7278156 L46.5372719,60.0527615 L45.7853868,70.4493401 L59.7241796,66.8505738 C59.6162166,67.7027103 59.4684101,68.556132 59.2601958,69.4108389 C56.2140972,82.0026649 43.5387284,89.7412976 30.9481877,86.695199 C18.3563617,83.6491005 10.617729,70.9737317 13.6625423,58.3819057 C15.1945885,52.0467919 19.1673694,46.946826 24.33674,43.823611 Z M43.4137998,13.3101862 L48.6757102,36.1186525 L64.4036039,19.7314134 L57.6931901,41.3240108 L66.2042723,39.7495506 L61.9127435,48.4084392 L87,48.6372179 L69.2709352,57.1778613 L75.0533814,59.7728289 L64.5334165,66.1028016 L62.6800519,63.0245712 L67.3096076,60.2380979 L60.7457151,57.2948213 L71.5471548,52.0920335 L56.1444354,51.9506534 L59.792042,44.5911764 L52.4942582,45.9407138 L56.4503305,33.2075077 L46.6681127,43.401013 L42.5732308,25.656525 L37.05041,40.2083933 L31.3605035,34.9194922 L30.4967996,38.140388 L27.0239902,37.2085646 L29.4364488,28.2245017 L35.585198,33.9388284 L43.4137998,13.3101862 Z M75.8699157,28.3728223 C78.3851963,31.7890797 79.48282,36.2091358 78.5561377,40.6369035 L69.1517903,37.9635343 L75.8699157,28.3728223 Z M59.2923791,14.140353 L59.6205865,14.2917497 L52.6698266,21.4494387 L48.9258244,14.0051337 C52.3661164,12.5713681 56.1006575,12.7205427 59.2923791,14.140353 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#1C7B97",
    fillRule: "evenodd",
    xlinkHref: "#explosives-a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosives);
export default __webpack_public_path__ + "static/media/explosives.66f8fa23.svg";
export { ForwardRef as ReactComponent };